import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { scrollMixin } from 'theme/MuiThemeProvider/mixins';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  paper: {
    minWidth: '720px',
  },
  paperMobile: {
    minWidth: 'unset',
    padding: '14px',
  },
  subtitle: {
    marginBottom: '24px',
    fontSize: '14px',
    lineHeight: '21px',
    color: customTheme.custom.black.B70,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: '16px',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 -14px -8px 0',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginTop: '-8px',
    },
  },
  cancelButton: {
    minWidth: '80px',
    marginRight: '8px',
    color: customTheme.custom.black.B70,
  },
  confirmButton: {
    minWidth: '90px',
    color: customTheme.custom.success,
  },
  inputStyles: {
    padding: '14px 16px',
    borderRadius: '16px',

    '& .MuiInputBase-input': {
      overflowX: 'hidden',
      ...scrollMixin,
    },
  },
};
